export const today = require("./dashboard_usage_today.json");
export const yesterday = require("./dashboard_usage_yesterday.json");
export const week = require("./dashboard_usage_week.json");
export const month = require("./dashboard_usage_month.json");
